import React from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from 'common/react/utils/translations';
import { getGlossaryDefinitionFromColumnId } from 'widgets/statspro/js/components/common/utils';
import { StatsTableHead } from 'widgets/statspro/js/components/common/stats-table/StatsTableHead';

export const StatsLeadersTableHead = ({ headerGroup }) => (
    <StatsTableHead
        headerGroup={headerGroup}
        skipColumns={['position', 'team']}
        primaryTooltipComponent={(column) => (
            <strong style={{ fontWeight: 500 }}>
                {getTranslation(`label.statsLeaders.${column.id}.name`)}
            </strong>
        )}
        secondaryTooltipComponent={(column) => {
            const glossaryDefinition = getGlossaryDefinitionFromColumnId(
                column.id
            );

            if (glossaryDefinition) {
                return <SecondaryTooltip content={glossaryDefinition} />;
            }

            return null;
        }}
    />
);

const SecondaryTooltip = ({ content }) => {
    return (
        <div className="stats-leaders-table-header-tooltip-secondary">
            <div className="stats-leaders-table-header-tooltip-secondary__border" />
            <p>{content}</p>
        </div>
    );
};

StatsLeadersTableHead.propTypes = {
    headerGroup: PropTypes.object.isRequired
};

SecondaryTooltip.propTypes = {
    content: PropTypes.any.isRequired
};
